import { render, staticRenderFns } from "./AList.vue?vue&type=template&id=2ec887fe&scoped=true&"
import script from "./AList.vue?vue&type=script&lang=js&"
export * from "./AList.vue?vue&type=script&lang=js&"
import style0 from "./AList.vue?vue&type=style&index=0&id=2ec887fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec887fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
